import { AgGridReact } from "ag-grid-react"
import "ag-grid-community/dist/styles/ag-grid.css"
import "ag-grid-community/dist/styles/ag-theme-alpine.css"
import "ag-grid-enterprise"
import { LicenseManager } from "ag-grid-enterprise"
import React, { useState, useRef, useEffect, useMemo, useCallback } from "react"
import { Row, Col, Container, Button, CardBody } from "reactstrap"
import { Link } from "react-router-dom"
import { useSelector, useDispatch } from "react-redux"
import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"

import {
  fetchQualityRatingListingBySection,
  changeQualityRatingStatus,
  updateQualityRatingPosition,
} from "store/actions"
import ActiveInactive from "./ActiveInactive"
import BtnCellRenderer from "./BtnCellRenderer"

const ListQualityRating = props => {
  const dispatch = useDispatch()

  let key = `${process.env.REACT_APP_AG_GRID_LICENSE_KEY}`
  LicenseManager.setLicenseKey(key)
  document.title = "Quality Rating List"

  const gridRef = useRef()

  const [rowData, setRowData] = useState([])
  const [rowPositions, setRowPositions] = useState([])

  const columnDefination = [
    {
      field: "action",
      cellRenderer: "BtnCellRenderer",
      maxWidth: 200,
      cellRendererSelector: params => {
        const buttons = {
          component: BtnCellRenderer,
        }
        if (params) return buttons
        else return undefined
      },
    },
    {
      headerName: "Name",
      rowDrag: true,
      field: "quality_rating",
    },
    {
      headerName: "Status",
      field: "status",
      cellRenderer: "ActiveInactive",
      cellRendererSelector: params => {
        const buttons = {
          component: ActiveInactive,
          params: {
            callChangeQualityRatingStatus: callChangeQualityRatingStatus,
          },
        }
        if (params) return buttons
        else return undefined
      },
    },
  ]
  const [columnDefs, setColumnDefs] = useState(columnDefination)

  const defaultColDef = useMemo(
    () => ({
      flex: 1,
      sortable: true,
      filter: true,
      minWidth: 200,
      resizable: true,
    }),
    []
  )

  const onGridReady = useCallback(params => {
    // remove previous records
    setRowData([])
    // access the Grid API
    gridRef?.api?.deselectAll()

    gridRef?.current?.api?.setFilterModel(null)
    // access the Grid Column API
    gridRef?.columnApi?.resetColumnState()

    // refresh the grid
    gridRef?.api?.redrawRows()
  }, [])

  const { error, loading, msg, qualityRatings, positionUpdate } = useSelector(
    state => ({
      error: state.QualityRating.error,
      loading: state.QualityRating.loading,
      msg: state.QualityRating.msg,
      qualityRatings: state.QualityRating.qualityRating,
      positionUpdate: state.QualityRating.positionUpdate,
    })
  )

  useEffect(() => {
    let qualityRatingData = { section: "quality_rating" }
    dispatch(fetchQualityRatingListingBySection(qualityRatingData))
  }, [])

  useEffect(() => {
    if (qualityRatings && qualityRatings.length > 0) {
      setRowData(qualityRatings)
      if (columnDefination && qualityRatings && qualityRatings.length > 0) {
        gridRef?.current?.api?.setColumnDefs(columnDefination)
      }
    }
  }, [qualityRatings])

  const onRowDragEnd = useCallback(e => {
    let allNodes = e.api.getRenderedNodes()
    let updatedNodes = []
    if (Array.isArray(allNodes) && allNodes.length) {
      allNodes.forEach(function (arrayItem) {
        updatedNodes.push({
          id: arrayItem.data.id,
          position: arrayItem.rowIndex,
        })
      })
      setRowPositions(updatedNodes)
    }
  }, [])

  function callChangeQualityRatingStatus(id) {
    dispatch(changeQualityRatingStatus(id))
  }

  function updatePositions() {
    if (rowPositions.length) {
      // api call
      dispatch(
        updateQualityRatingPosition({
          section: "quality_rating",
          nodes: rowPositions,
        })
      )
    }
  }

  useEffect(() => {
    if (error) {
      toast.dismiss()
      toast.error(error, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
      })
    } else if (positionUpdate && msg) {
      toast.dismiss()
      toast.success(msg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
      })
      setRowPositions([])
    }
  }, [msg, positionUpdate, error])

  return (
    <React.Fragment>
      <div className="account-pages my-5 pt-sm-5">
        <Container fluid={true}>
          {msg || error ? <ToastContainer /> : ""}
          <Row>
            <Col>
              <h5>Quality Ratings</h5>
            </Col>
            <Col>
              <div className="d-flex justify-content-end">
                <Link
                  className="btn btn-primary mb-2"
                  to="/dropdown/quality_rating/add"
                >
                  Add
                </Link>
                {rowPositions.length ? (
                  <button
                    className="btn btn-secondary mb-2 mx-1"
                    onClick={updatePositions}
                  >
                    Update Positions
                  </button>
                ) : (
                  ""
                )}
              </div>
            </Col>
          </Row>
          <Row>
            <Col md={12} lg={12} xl={12}>
              <div
                className="ag-theme-alpine"
                style={{ width: "100%", height: "80vh" }}
              >
                <AgGridReact
                  ref={gridRef}
                  rowData={rowData}
                  animateRows={true}
                  columnDefs={columnDefs}
                  defaultColDef={defaultColDef}
                  rowDragManaged={true}
                  onRowDragEnd={onRowDragEnd}
                  enableCellChangeFlash={true}
                  suppressChangeDetection={true}
                  onGridReady={onGridReady}
                />
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default ListQualityRating
